import { RestClient } from './RestClient'
import store from 'src/store'

export class StatisticsClient extends RestClient {
  /**
   * StatisticsClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/statistics`
  }

  /**
   * Get a list of all statistics for the current company
   *
   * @returns {AxiosPromise}
   */
  list (data) {
    return this.call('post', this.baseUrl, data)
  }
}
